/**
 @author xcf
 @date 2020/6/29 10:53 上午
 */




import {pictureList} from "../../../createScreen/script/comChart";


let chilCharts = [];

pictureList.map((item, index) => {
    chilCharts.push({
        name: '图片' + (index + 1),
        //多维分析图标
        ordImg:item.img,
        //大屏图标
        bigImg:item.img,
        //默认配置
        chartParam: {
            borImg:item.img,
        },
        //维度配置
        wdParam: {},
        //度量配置
        dlParam: {},
    })
});

export default {
    //类型
    type: 'picture',
    //类别
    class: 'elem',
    //组件名称
    name: '图片',
    //图标
    iconImg: '/image/viewElement/picture.png',
    //大屏图标
    bigIconImg: '/image/viewElement/picture.png',
    //是否在多维分析展示
    viewType: false,
    //基础配置
    option: {
        //最小维度数量
        minWDLength: 0,
        //最小度量数量
        minDLLength: 0,
        //最大维度数量
        maxWDLength: 0,
        //最大度量数量
        maxDLLength: 0,
        //高
        dp_height: 400,
        //宽
        dp_wight: 400,
        //最小高
        dp_min_height: 10,
        //宽宽
        dp_min_wight: 50,
        //是否展示维度配置
        isWdConfig: false,
        //是否展示度量配置
        isDlConfig: false,
        //是否展示JSON配置
        isJSONConfig: false,
        //是否展示公共配置
        isComConfig: false,
        //是否展示边框
        isComBorder: false,
    },
    component: () => import('./component/pictureCom.vue'),
    // 子集展示的配置项
    chilCharts: chilCharts,
    //维度组件
    wdComponent: null,
    //维度参数
    wdHandle(option) {
        return {}
    },
    //度量组件
    dlComponent: null,
    //度量参数
    dlHandle(option) {
        return {}
    },
    //配置参数
    params(option) {
        return {
            borImg: '.',
            opacity: 1,
        }
    },
    //配置组件列表
    configModule: [
        {
            name: '图片配置',
            component: () => import('./config/picture_config')
        },],
    //接口
    JSONData: {
        //静态数组
        listDaVal: '',
        //接口参数
        params: {},
        //引用的组件
        jsonPonent: null,
    },
    //静态转换数据回调
    JSONRender(json, chart, nowChart, viewDP) {
    },
    //切换图表之前的回调
    renderBefore(chart, nowChart, dom) {

    },
    //渲染
    rendering(chart, nowChart, dom) {

    }
}
